<template>
    <form-row title="Has Commission Statement Been Ordered?">
        <input-radio-boolean
            name="ordered_commission_statement"
            :value="closing.ordered_commission_statement"
            true="Yes"
            false="No"
            :read_only="read_only"
        />
    </form-row>
</template>

<script>
export default {
    props: {
        closing: { default: () => ({}) },
        read_only: { default: false },
    },
}
</script>
